import Checkbox from "@ingka/checkbox";
import Hyperlink from "@ingka/hyperlink";
import SSRIcon from "@ingka/ssr-icon";
import starEmpty from "@ingka/ssr-icon/paths/star";
import starFilled from "@ingka/ssr-icon/paths/star-filled";
import Text from "@ingka/text";
import TextArea from "@ingka/text-area";
import { useState } from "react";
import { Feedback } from "./types";

type Props = {
  onFeedback: (feedback: Feedback) => void;
  feedback: Feedback;
};

const UploadFeedback = ({ onFeedback, feedback }: Props): JSX.Element => {
  const { rating, comment, allowContact } = feedback;
  const [hover, setHover] = useState(0);

  return (
    <>
      <div className="flex flex-col gap-y-space125">
        <fieldset className="star-input flex gap-x-space300">
          {[...Array(5)].map((_, index) => {
            const currentRating = index + 1;
            const starIcon =
              currentRating <= (hover || rating) ? starFilled : starEmpty;
            return (
              <label
                className="star-input-label"
                key={`rating-${currentRating}`}
              >
                <span className="star-sr">{`${currentRating} out of 5 stars`}</span>
                <input
                  type="radio"
                  name="rating"
                  value={rating}
                  className="star-input"
                  onClick={() => {
                    onFeedback({
                      rating: currentRating,
                      comment,
                      allowContact,
                    });
                  }}
                  onMouseEnter={() => setHover(currentRating)}
                  onMouseLeave={() => setHover(0)}
                />
                <SSRIcon className="star-svg" paths={starIcon} ariaHidden />
              </label>
            );
          })}
        </fieldset>
        <TextArea
          id="upload-feedback"
          className="text-sm"
          label="Do you have any additional feedback?"
          value={comment}
          onBlur={() => {
            const trimmedComment = comment.trim();
            if (trimmedComment !== comment) {
              onFeedback({
                rating,
                comment: trimmedComment,
                allowContact,
              });
            }
          }}
          onChange={(e) => {
            onFeedback({
              rating,
              comment: e.target.value,
              allowContact,
            });
          }}
        />
        <Checkbox
          id="feedback-consent-id"
          label={<Text bodySize="s">I wish to remain anonymous</Text>}
          value=""
          checked={!allowContact}
          onChange={(e) => {
            onFeedback({
              rating,
              comment,
              allowContact: !e.target.checked,
            });
          }}
        />
      </div>
      <div className="mt-space125 max-w-xl">
        <Text tagName="p" bodySize="s" className="w-full text-center">
          Your response may be used to improve the Uploader tool. If you choose
          not to remain anonymous, we may contact you for clarification about
          your rating or comment so that we can continue to improve. Leave more
          extensive feedback or report a problem{" "}
          <Hyperlink
            newWindow
            url="https://jira.digital.ingka.com/servicedesk/customer/portal/16/create/7009"
            text="here."
          />
        </Text>
      </div>
    </>
  );
};

export default UploadFeedback;
